import React from 'react'

const Hero = () => (
  <section className="hero">
    <h2>Innovación en Ingeniería</h2>
    <p>Soluciones técnicas de excelencia para proyectos industriales y constructorales</p>
    <div>
      <a href="/contacto" className="btn">Contactar</a>
    </div>
  </section>
)

export default Hero